import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCompare({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 10a3 3 0 013 3v5a3 3 0 01-3 3H6a3 3 0 01-3-3v-5a3 3 0 013-3h5zm0 2H6a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1zm-1-9h8a3 3 0 012.995 2.824L21 6v8a3 3 0 01-2.824 2.995L18 17h-1a1 1 0 01-.117-1.993L17 15h1a1 1 0 00.993-.883L19 14V6a1 1 0 00-.883-.993L18 5h-8a1 1 0 00-.993.883L9 6v1a1 1 0 01-1.993.117L7 7V6a3 3 0 012.824-2.995L10 3h8-8z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCompare
